import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import logo from '../leclab-madrid-vertical.png';

function RecoverPass() {
    const navigate = useNavigate()
    const [message, setMessage] = useState(false)
    const [email, setEmail] = useState('')
    const [validMail, setValidMail] = useState(true)
    const [submitLoading, setSubmitLoading] = useState(false)

    const { forgotPassword } = useAuth()

    const makeChange = (e) => {
        e.preventDefault()
        //  Invalid email
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(e.target.value)) {
            setValidMail(false)
        }
        setEmail(e.target.value)
    }

    const doSubmit = (e) => {
        e.preventDefault()
        if (!email) return
        setSubmitLoading(true)
        forgotPassword(email)
            .then(response => setMessage(true))
            .catch(e => {
                alert("Ha habido un error, por favor, intente más tarde")
                console.log('error: ', e.message)
            })
            .finally(() => setSubmitLoading(false))
    }

    if (message) return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className="card-header bg-transparent">
                    <img alt="Leclab Madrid" width="300" src={logo} />
                </div>
                <div className="card-body">
                    <p>Se ha enviado un email a su dirección de correo electrónico. No olvide revisar la bandeja de Spam.</p>
                    <button type="submit" className="btn btn-login btn-block w-100" onClick={e => {e.preventDefault(); navigate('/')}}>Ir a Login</button>

                </div>
            </div>
        </div>
    )

    return (
        <div className="auth-wrapper">
            <div className="auth-inner">

                <div className="card-header bg-transparent">
                    <img alt="Leclab Madrid" width="300" src={logo} />
                </div>

                <div className="card-body">
                    <form onSubmit={doSubmit}>
                        <div className="form-group d-block">
                            <div className="mb-3">
                                <input type="email" className="form-control" placeholder="Correo electrónico" value={email} onChange={makeChange} />
                                {/* <p className="mt-1 text-danger">{email.error && email.error}</p> */}
                            </div>
                            {!submitLoading && <button type="submit" disabled={validMail} className="btn btn-login btn-block w-100">Restablecer Contraseña</button>}
                            {submitLoading &&
                                <button className="btn btn-login btn-block w-100" type="button" disabled>
                                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                    Loading...
                                </button>
                            }
                        </div>
                    </form>
                </div>

            </div>
        </div>

    );
};

export default RecoverPass;